/**
 * External Dependencies
 */
import 'jquery';
import 'lity';
import lozad from 'lozad';
import { WOW } from 'wowjs';
import { gsap, ScrollTrigger, ScrollToPlugin, TweenMax } from 'gsap/all';
import { each } from 'jquery';
import Swiper from 'swiper/bundle';

$(() => {
    var wow = new WOW({
        live: false,
    });
    wow.init();

    const observer = lozad();
    observer.observe();

    gsap.install(window);

    gsap.registerPlugin(ScrollTrigger);

    $('[data-fancybox]').fancybox();

    /*
    |------------------------------------------
    |  Safari Height
    |------------------------------------------
    */

    var appHeight = () => {
        /*var doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);*/
    };

    window.addEventListener('resize', appHeight);
    appHeight();
    if ($('.stay-indicator').length) {
        var stickyOffset = $('.stay-indicator').offset();
        var $contentDivs = $('section');
        $(document).scroll(function() {
            $contentDivs.each(function(k) {
                var _thisOffset = $(this).offset();
                var _actPosition = _thisOffset.top - $(window).scrollTop() - 140;
                var indicatoreHeight = $('.stay-indicator').height();
                if (
                    _actPosition < stickyOffset.top &&
                    _actPosition + $(this).height() > 0
                ) {
                    $('.stay-indicator a')
                        .removeClass('text-white text-black')
                        .addClass(
                            $(this).hasClass('indicator-black') ? 'text-black' : 'text-white'
                        );
                    $('.navinner-main > div')
                        .removeClass('border-white border-black')
                        .addClass(
                            $(this).hasClass('indicator-black') ?
                            'border-black' :
                            'border-white'
                        );
                    return false;
                }
            });
        });
    }

    /** Add to trip Session Store Start **/

    if ($('.splash-screen').length) {
        $('html').addClass('overflow-hidden');
    }
    $(document).keypress(function(event) {
        if ($('.splash-screen').length) {
            var keycode = event.keyCode ? event.keyCode : event.which;

            if (keycode == 13) {
                remove_enterscreen();
            }
        }
    });

    $('body').on('click', '.splash-screen', function() {
        if ($('.splash-screen').length) {
            remove_enterscreen();
        }
    });

    function remove_enterscreen() {
        var str = '&enter_screen=first_screen' + '&action=enter_screen';
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: ajax_object.ajaxurl,
            data: str,
            success: function(data) {
                $('[data-splash-screen]').remove();
                $('html').removeClass('overflow-hidden');
                let tl = gsap.timeline();
                tl.from('.navbar > div', {
                    duration: 0.6,
                    y: 150,
                    autoAlpha: 0,
                    ease: Power3.out,
                    stagger: {
                        each: 2,
                        amount: 0.5,
                    },
                }).from(
                    '.banner-content > div ', {
                        duration: 0.4,
                        y: 150,
                        autoAlpha: 0,
                        ease: Power3.out,
                        stagger: {
                            each: 0.75,
                            amount: 0.5,
                        },
                    },
                    '+=0.25'
                );
            },
        });
    }


    /** Check # value  **/
    var hash = $(location).prop('hash');
    if (hash) {
        var hash = hash.replace('#', '');
        if ($('.tabs').length) {
            if ($('#' + hash).length) {
                $('#' + hash)
                    .parent('ul')
                    .children('li')
                    .removeClass('active');
                $('#' + hash).addClass('active');
                $('body .tabs_container .tab_content[data-tab=' + hash + ']')
                    .parent()
                    .children('.tab_content')
                    .removeClass('active');
                $('body .tabs_container .tab_content[data-tab=' + hash + ']').addClass(
                    'active'
                );
            }
        }
    }

    $('.footer-copyright ul a').click(function() {
        var location = $(this).attr('href');
        var id = location.split('/#').pop();
        console.log(id);
        $('#' + id)
            .parent('ul')
            .children('li')
            .removeClass('active');
        $('#' + id).addClass('active');
        $('body .tabs_container .tab_content[data-tab=' + id + ']')
            .parent()
            .children('.tab_content')
            .removeClass('active');
        $('body .tabs_container .tab_content[data-tab=' + id + ']').addClass(
            'active'
        );
    });

    /*
    |------------------------------------------
    |  Tabs
    |------------------------------------------
    */
    if ($('.tabs').length) {
        $('ul.tabs li').click(function() {
            var $this = $(this);
            var $theTab = $(this).attr('id');
            if ($this.hasClass('active')) {
                // do nothing
            } else {
                $this
                    .closest('.tabs_wrapper')
                    .find('ul.tabs li, .tabs_container .tab_content')
                    .removeClass('active');
                $('.tabs_wrapper .slide-arrow').removeClass('!flex');
                $('.tabs_wrapper .slide-arrow').addClass('!hidden');
                $(
                    '.tabs_container .tab_content[data-tab="' +
                    $theTab +
                    '"], ul.tabs li[id="' +
                    $theTab +
                    '"]'
                ).addClass('active');
                $(
                    '.tabs_wrapper .slide-arrow[data-arrow="' + $theTab + '"]'
                ).removeClass('!hidden');
                $('.tabs_wrapper .slide-arrow[data-arrow="' + $theTab + '"]').addClass(
                    '!flex'
                );

                // fadeinup animation
                const boxes = gsap.utils.toArray(
                    '.animated-boxes .tabs_container .tab_content[data-tab="' +
                    $theTab +
                    '"] .animated-item'
                );
                boxes.forEach((box, i) => {
                    const anim = gsap.fromTo(
                        box, { autoAlpha: 0, y: 50 }, { duration: 1, autoAlpha: 1, y: 0 }
                    );
                    ScrollTrigger.create({
                        trigger: box,
                        animation: anim,
                        toggleActions: 'play none none none',
                        once: true,
                    });
                });

                // fadeinup animation
                const boxess = gsap.utils.toArray(
                    '.animated-boxes-fadein .tabs_container .tab_content[data-tab="' +
                    $theTab +
                    '"] .animated-item-fadein'
                );
                boxess.forEach((box, i) => {
                    const anim1 = gsap.fromTo(
                        box, {
                            autoAlpha: 0,
                            opacity: 0
                        }, {
                            duration: 1,
                            autoAlpha: 1,
                            opacity: 1
                        }
                    );
                    ScrollTrigger.create({
                        trigger: box,
                        animation: anim1,
                        toggleActions: 'play none none none',
                        once: true,
                    });
                });

            }
        });
    }

    $('body').on('click', '.changeYear', function() {
        var villa = $(this).data('villa');
        var year = $(this).data('year');
        $('.ul-' + villa + ' li').removeClass('active');
        $('.' + villa).css('display', 'none');
        $(this).addClass('active').show();
        $('.' + year).css('display', 'flex');
    });

    $('body').on('change', '.changePrice', function() {
        var NewPrice = $(this).val();
        $(this).siblings().children('.updatePrice').text(NewPrice);
    });

    /*
    |------------------------------------------
    |  Menu
    |------------------------------------------
    */
    function menuOpen() {
        $('html').addClass('overflow-hidden');
        $('body').addClass('menu-open');
        $('.hamburger').addClass('active');
        $('.navbar-nav').addClass('menuhide');
    }

    function menuClose() {
        $('html').removeClass('overflow-hidden');
        $('body').removeClass('menu-open');
        $('.hamburger').removeClass('active');
        $('.navbar-nav').removeClass('menuhide');
    }
    let t1 = gsap.timeline({
        paused: true,
        onStart: menuOpen,
        onReverseComplete: menuClose,
    });
    t1.to('.nav-container', {
        duration: 0.8,
        transform: 'translateX(0px)',
        // clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        // right: 0,
        ease: 'Power3.InOut',
    });
    t1.from(
        '.main-nav__col ', {
            stagger: 0.05,
            opacity: 0,
            y: 20,
            ease: 'Power3.InOut',
        },
        '-=0'
    );
    t1.reverse();

    $('.menu-open-test').on('click', function() {
        t1.reversed(!t1.reversed());
    });

    /*
    |------------------------------------------
    |  FadeInUp Gsap Animation
    |------------------------------------------
    */
    if ($('.animated-boxes').length) {
        const boxes = gsap.utils.toArray(
            '.animated-boxes .animated-item,body .fadeInUp'
        );
        boxes.forEach((box, i) => {
            const anim = gsap.fromTo(
                box, {
                    autoAlpha: 0,
                    y: 80,
                }, {
                    duration: 1,
                    autoAlpha: 1,
                    y: 0,
                }
            );
            ScrollTrigger.create({
                trigger: box,
                animation: anim,
                toggleActions: 'play none none none',
                once: true,
            });
        });
    }

    if ($('.animated-boxes-fadein').length) {
        const boxess = gsap.utils.toArray(
            '.animated-boxes-fadein .animated-item-fadein'
        );
        boxess.forEach((box, i) => {
            const anim1 = gsap.fromTo(
                box, {
                    autoAlpha: 0,
                    opacity: 0
                }, {
                    duration: 1,
                    autoAlpha: 1,
                    opacity: 1
                }
            );
            ScrollTrigger.create({
                trigger: box,
                animation: anim1,
                toggleActions: 'play none none none',
                once: true,
            });
        });
    }

    /*
    |------------------------------------------
    |  According
    |------------------------------------------
    */
    $('.accordion .panel-heading').click(function() {
        $(this).siblings('.panel-collapse').slideToggle();
        $(this).find('i').toggleClass('fa-plus fa-minus');
    });

    /*
    |------------------------------------------
    |  Single Slider
    |------------------------------------------
    */
    if ($('.alfajiri-slider').length) {
        var alfajiriSlider = {
            // Slider Settings
            settings: {
                currentSlide: 1,
                totalSlides: 0,
                animating: false,
                autoPlay: true,
                autoPlaySpeed: 5, // Increase to stay on slides for longer
                transitionSpeed: 2, // Changes transition speed
                autoPlayInterval: false,
                ease: 'expo',
                timeline: gsap.timeline({}),
                imageScale: '',
                controls: {
                    next: document.querySelector('.alfajiri__next'),
                    prev: document.querySelector('.alfajiri__prev'),
                    nav: document.querySelectorAll('.alfajiri__navpoint'),
                },
            },

            // Initiate Slider
            init: function() {
                this.settings.totalSlides =
                    document.querySelectorAll('.alfajiri__slide').length;
                this.settings.controls.prev.addEventListener('click', () => {
                    this.stopAutoPlay();
                    this.changeSlide('prev');
                });
                this.settings.controls.next.addEventListener('click', () => {
                    this.stopAutoPlay();
                    this.changeSlide('next');
                });
                this.settings.controls.nav.forEach((el, key) => {
                    el.addEventListener('click', () => {
                        this.stopAutoPlay();
                        this.jumpToSlide(key + 1);
                    });
                });

                this.settings.imageScale = gsap.to(
                    '.slide--active .slide__image img',
                    15, {
                        scale: 1.1,
                        ease: 'sine.inOut',
                        yoyo: true,
                        yoyoEase: true,
                        repeat: -1,
                    }
                );

                if (this.settings.autoPlay) {
                    this.autoPlay();
                }
            },

            // Change Slide
            changeSlide: function(dir) {
                // console.log(this.settings.animating);
                if (this.settings.animating) return;
                let animateFrom = this.settings.currentSlide;
                if (dir === 'next') {
                    if (this.settings.currentSlide >= this.settings.totalSlides) {
                        this.settings.currentSlide = 1;
                    } else {
                        this.settings.currentSlide++;
                    }
                } else {
                    if (this.settings.currentSlide <= 1) {
                        this.settings.currentSlide = this.settings.totalSlides;
                    } else {
                        this.settings.currentSlide--;
                    }
                }
                this.slideAnimation(animateFrom, this.settings.currentSlide, dir);
            },

            // Slide Navigation
            jumpToSlide: function(slide) {
                if (this.settings.animating || slide === this.settings.currentSlide)
                    return;
                let animateFrom = this.settings.currentSlide;
                this.settings.currentSlide = slide;
                if (slide > animateFrom) {
                    var dir = 'next';
                } else {
                    var dir = 'prev';
                }

                this.slideAnimation(animateFrom, this.settings.currentSlide, dir);
            },

            // Autoplaying
            autoPlay: function() {
                this.settings.autoPlay = true;

                let el =
                    this.settings.controls.nav[this.settings.currentSlide - 1].children[0]
                    .children[0];
                this.settings.timeline.fromTo(
                    el,
                    this.settings.autoPlaySpeed - this.settings.transitionSpeed, {
                        x: '-100%',
                    }, {
                        x: 0,
                        ease: 'none',
                        delay: 0.3,
                        onComplete: () => {
                            this.changeSlide('next');
                        },
                    }
                );
            },

            stopAutoPlay: function() {
                if (this.settings.autoPlay) {
                    this.settings.timeline.progress(100);
                }
                this.settings.autoPlay = false;
            },

            // Update Nav
            updateNav: function(from, to) {
                gsap.to(
                    this.settings.controls.nav[from - 1].children[0],
                    this.settings.transitionSpeed, {
                        width: '0',
                        ease: this.settings.ease + '.inOut',
                    }
                );
                gsap.to(
                    this.settings.controls.nav[from - 1].children[1],
                    this.settings.transitionSpeed, {
                        ease: this.settings.ease + '.inOut',
                    }
                );
                gsap.to(
                    this.settings.controls.nav[to - 1].children[0],
                    this.settings.transitionSpeed, {
                        width: '100%',
                        ease: this.settings.ease + '.inOut',
                    }
                );
                gsap.to(
                    this.settings.controls.nav[to - 1].children[1],
                    this.settings.transitionSpeed, {
                        ease: this.settings.ease + '.inOut',
                    }
                );
                gsap.to(
                    this.settings.controls.nav[from - 1].children[0].children[0],
                    this.settings.transitionSpeed, {
                        x: '100%',
                        ease: this.settings.ease + '.inOut',
                    }
                );
            },

            // Slide Animation
            slideAnimation: function(from, to, dir) {
                this.settings.animating = true;

                // console.log(this.settings.animating);

                this.updateNav(from, to);

                from = '.alfajiri__slide[data-slide="' + from + '"]';
                to = '.alfajiri__slide[data-slide="' + to + '"]';

                this.settings.timeline.clear();
                this.settings.timeline.play(0);

                this.settings.timeline
                    .set(to, {
                        display: 'block',
                    })
                    .to(
                        from + ' .slide__content *',
                        (this.settings.transitionSpeed / 100) * 40, {
                            y: 0,
                            opacity: 1,
                            ease: this.settings.ease + '.in',
                            stagger: 0.1,
                        },
                        'slideAnimation'
                    )
                    .fromTo(
                        to + ' .slide__content *',
                        (this.settings.transitionSpeed / 100) * 40, {
                            y: 0,
                            opacity: 1,
                        }, {
                            y: 0,
                            opacity: 1,
                            ease: 'Power3.out',
                            stagger: 0.1,
                        },
                        '>0.5'
                    )
                    .fromTo(
                        from + ' .slide__image',
                        this.settings.transitionSpeed, {
                            display: 'block',
                            x: '0%',
                        }, {
                            x: dir === 'next' ? '-100%' : '100%',
                            ease: this.settings.ease + '.inOut',
                        },
                        'slideAnimation'
                    )
                    .fromTo(
                        from + ' .slide__image img',
                        this.settings.transitionSpeed, {
                            transformOrigin: 'center',
                            x: '0%',
                        }, {
                            x: dir === 'next' ? '50%' : '-50%',
                            ease: this.settings.ease + '.inOut',
                        },
                        'slideAnimation'
                    )
                    .fromTo(
                        to + ' .slide__image img',
                        this.settings.transitionSpeed, {
                            transformOrigin: 'center',
                            x: dir === 'next' ? '-50%' : '50%',
                        }, {
                            x: '0%',
                            ease: this.settings.ease + '.inOut',
                        },
                        'slideAnimation'
                    )
                    .fromTo(
                        to + ' .slide__image',
                        this.settings.transitionSpeed, {
                            display: 'block',
                            transformOrigin: 'right center',
                            x: dir === 'next' ? '100%' : '-100%',
                        }, {
                            x: '0%',
                            ease: this.settings.ease + '.inOut',
                            onComplete: () => {
                                this.settings.animating = false;
                                gsap.set(from, {
                                    display: 'none',
                                });
                                this.settings.imageScale.kill();
                                gsap.set(from + ' .slide__image', {
                                    scale: 1,
                                });
                                this.settings.imageScale = gsap.to(
                                    to + ' .slide__image img',
                                    15, {
                                        scale: 1.1,
                                        ease: 'sine.inOut',
                                        yoyo: true,
                                        yoyoEase: true,
                                        repeat: -1,
                                    }
                                );
                            },
                        },
                        'slideAnimation'
                    );

                if (this.settings.autoPlay) {
                    let el =
                        this.settings.controls.nav[this.settings.currentSlide - 1]
                        .children[0].children[0];
                    this.settings.timeline.fromTo(
                        el,
                        this.settings.autoPlaySpeed - this.settings.transitionSpeed, {
                            x: '-100%',
                        }, {
                            x: 0,
                            ease: 'none',
                            onComplete: () => {
                                this.changeSlide('next');
                            },
                        },
                        '>'
                    );
                }
            },
        };
        // Slider INIT
        alfajiriSlider.init();
    }

    /*
    |------------------------------------------
    |  Smooth Scroll
    |------------------------------------------
    */
    if (!$('body').hasClass("single-villa")) {
      $(document).on('click', '.stay-indicator a[href^="#"]', function(event) {
          event.preventDefault();

          $('html, body').animate({
                  scrollTop: $($.attr(this, 'href')).offset().top,
              },
              1500
          );
      });
    }

    if (!$('body').hasClass("single-villa")) {
      $('.stay-indicator a').bind('click', function(e) {
          e.preventDefault();
          var target = $(this).attr('href');
          $('html, body')
              .stop()
              .animate({
                      scrollTop: $(target).offset().top + 50,
                  },
                  600
              );
          return false;
      });
  }

  $( document ).ready(function() {
    $(window)
          .scroll(function() {
              var scrollDistance = $(window).scrollTop();
              $('.sec-nav').each(function(i) {
                if (($(this).position().top - 600) < scrollDistance) {
                  $('.stay-indicator li.active').removeClass('active');
                  $('.stay-indicator li').eq(i - 1).addClass('active');
                }
              });
          })
          .scroll();
  })

    /*
    |------------------------------------------
    |  Boxes FadeInUp
    |------------------------------------------
    */
    if (!$('body').hasClass("single-villa")) {
      $('.stay-indicator a').click(function() {
          $(this).parents('ul').children('li').removeClass('active');
          $(this).parent('li').prev().addClass('active');
      });
    }

    /*
    |------------------------------------------
    |  Video Menu Popup
    |------------------------------------------
    */
    if ($('.video-menu-popup').length) {
      var video_url = jQuery('.video-menu-popup a').attr('href');
      jQuery(".video-menu-popup a").attr("href", "javascript:void(0)")
      jQuery('.video-menu-popup a').attr('data-fancybox', '');
      jQuery('.video-menu-popup a').attr('data-src', video_url);
    }

    /*
    |------------------------------------------
    |  Swiper slider
    |------------------------------------------
    */
        if ($('.zigzag-slider-container').length) {
            var Swipes = new Swiper('.zigzag-slider-container', {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                effect: 'fade',
                autoplay: {
                    delay: 2500,
                },
                loop: false,
            });
        }

    if ($('.single-slider').length) {
        var Swipess = new Swiper('.single-slider', {
            autoHeight: false,
            loop: true,
            navigation: {
                nextEl: '.single-slider .swiper-button-next',
                prevEl: '.single-slider .swiper-button-prev',
            },
            autoplay: {
                delay: 4000,
            },
        });
    }

    if ($('.awards-container').length) {
        new Swiper('.awards-container', {
            loop: true,
            navigation: {
                nextEl: '.awards-container .swiper-button-next',
                prevEl: '.awards-container .swiper-button-prev',
            },
            slidesPerView: 5,
            paginationClickable: true,
            spaceBetween: 20,
            breakpoints: {
                1025: {
                    slidesPerView: 5,
                    spaceBetween: 0,
                },
                480: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
                1: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
            },
        });
    }

    $('[data-src="#foundation"]').click(function() {
        $('.modal-content .content').mCustomScrollbar({
            theme: 'dark',
            mouseWheelPixels: 150,
        });
    });
});

$(window).on('load', function() {
    $('.page-loader').fadeOut(300);
});
